import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Navigation extends Component {
    render() {
        
        return (
                <nav>
                    <ul>
                        <li>
                            <NavLink to='/ueber-uns'>Über uns</NavLink>
                        </li>
                        <li>
                            <NavLink to='/service'>Service</NavLink>
                        </li>
                        <li>
                            <NavLink to='/unser-team'>Unser Team</NavLink>
                        </li>
                        <li>
                            <NavLink to='/kontakt'>Kontakt</NavLink>
                        </li>
                     </ul>
                </nav>
        );
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation.js